import * as Yup from 'yup';

export const general = [
  {
    name: 'country',
    initialValue: '',
    validation: Yup.string().required('Country is required.'),
    input: {
      placeholder: 'Select Country',
      className: 'country-details',
      type: 'input',
      as: 'select',
      options: ['Country'],
    },
  },
  {
    name: 'region-details',
    initialValue: '',
    validation: Yup.string().required('Region is required.'),
    input: {
      placeholder: 'Region',
      className: 'region-details',
      type: 'input',
      as: 'select',
      options: ['Region'],
    },
  },
  {
    name: 'default_language',
    initialValue: '',
    validation: Yup.string().required('Languague is required.'),
    input: {
      placeholder: 'language',
      className: 'language',
      type: 'input',
      as: 'select',
      options: ['Select language'],
    },
  },
  {
    name: 'timezone',
    initialValue: '',
    validation: Yup.string().required('Timezone is required.'),
    input: {
      placeholder: 'Timezone',
      className: 'timezone',
      type: 'input',
      as: 'select',
      options: ['Timezone'],
    },
  },
  {
    name: 'dateformat',
    initialValue: '',
    validation: Yup.string().required('Date format is required.'),
    input: {
      placeholder: 'Date format',
      className: 'date-format',
      type: 'input',
      as: 'select',
      options: ['Date format'],
    },
  },
  {
    name: 'numberformat',
    initialValue: '',
    validation: Yup.string().required('Number format is required.'),
    input: {
      placeholder: 'Number format',
      className: 'number-format',
      type: 'input',
      as: 'select',
      options: ['Number format'],
    },
  },
  {
    name: 'currency',
    initialValue: '',
    validation: Yup.string().required('Currency is required.'),
    input: {
      placeholder: 'Currency',
      className: 'currency',
      type: 'input',
      as: 'select',
      options: ['Currency'],
    },
  },
];

export const taxRateForm = [
  {
    name: 'name',
    initialValue: '',
    validation: Yup.string().required('Tax rate name is required.'),
    input: {
      placeholder: 'Tax rate name',
      className: 'tax-rate-name',
      type: 'input',
    },
  },
  {
    name: 'rate',
    initialValue: '',
    validation: Yup.string().required('Tax rate is required.'),
    input: {
      placeholder: 'tax rate',
      className: 'tax-rate',
      type: 'input',
    },
  },
  {
    name: 'code',
    initialValue: '',
    validation: Yup.string(),
    input: {
      placeholder: 'Tax rate code',
      className: 'tax-rate-code',
      type: 'input',
    },
  },
];

export const taxTableFields = [
  { key: 'name', title: 'Name' },
  { key: 'rate', title: 'Rate' },
  { key: 'code', title: 'Code' },
];
